import "./style.css";
import anchorme from "anchorme";
import {EXTERNAL_NAME} from "@meltwater/mi-manifest-client/build/external-name.js";

const sharableDashboardBuilderPreviewConfig = {
  name: "mwPrInsightSharableDashboardReportBuilderPreview",
  bindings: {
    dashboardId: "<",
    generateContent: "<?",
    isEditing: "=",
    isDirty: "=",
    linkConfig: "=",
    widgets: "=",
    creatingReportFlag: "=",
    toast: "=",
    contentAvailable: "=",
    showLoading: "=",
    showReport: "&",
    shareReport: "&",
  },
  template: `
        <mw-loader class="full-screen-loader" ng-show="$ctrl.requestInProgress"></mw-loader>

        <mw-pr-insight-sharable-dashboard-report-builder-loading ng-if="$ctrl.showLoading === true" content-available="$ctrl.contentAvailable" show-report="$ctrl.showReport()" share-report="$ctrl.shareReport()"></mw-pr-insight-sharable-dashboard-report-builder-loading>
        
        <div id="sharable-dashboard__action-buttons" ng-if="$ctrl.showLoading !== true && $ctrl.widgets !== undefined && $ctrl.widgets !== null && $ctrl.widgets.length > 0">

            <md-button md-no-ink ng-if="$ctrl.isEditing !== true" ng-click="$ctrl.editWidget()">
                <md-icon md-svg-icon="meltwater:edit"></md-icon>
                <md-tooltip>{{'Edit slide' | translate}}</md-tooltip>
            </md-button>
            <md-button md-no-ink ng-if="$ctrl.isEditing !== true" ng-click="$ctrl.deleteWidget($event)">
                <md-icon md-svg-icon="action:ic_delete_24px"></md-icon>
                <md-tooltip>{{'Delete slide' | translate}}</md-tooltip>
            </md-button>

            <md-button md-no-ink ng-if="$ctrl.isEditing === true" ng-click="$ctrl.saveWidget()">
                <md-icon md-svg-icon="navigation:ic_check_24px"></md-icon>
                <md-tooltip>{{'OK' | translate}}</md-tooltip>
            </md-button>
            <md-button md-no-ink  ng-if="$ctrl.isEditing === true" ng-click="$ctrl.cancel()">
                <md-icon md-svg-icon="navigation:ic_close_24px"></md-icon>
                <md-tooltip>{{'Cancel' | translate}}</md-tooltip>
            </md-button>
        </div>
        
        <div id="sharable-dashboard__preview__outter-container" class="reveal no-scroll" flex layout="row" layout-fill ng-show="$ctrl.showLoading !== true">
            <div ng-if="$ctrl.notFound === true" translate>Dashboard not found</div>
            <div ng-if="$ctrl.notFound !== true" layout-fill>
                <input type="hidden" ng-model="$ctrl.reportConfig.id" />
                <div id="sharable-dashboard-nav-panel" flex="20">
                    <div id="sharable-dashboard-nav-panel__widgets-container">
                        <div ng-repeat="w in $ctrl.widgets track by $index" class="sharable-dashboard-nav-panel__item" ng-class="{'active': $ctrl.$location.hash() === w.hashName}">
                            <label class="sharable-dashboard-nav-panel__label">{{($index+1)}}</label>
                            <a href="#{{w.hashName}}" ng-click="$ctrl.changeSlide()">
                                <div class="sharable-dashboard-nav-panel__thumbnail">
                                    <img src="{{w.thumbnailSrc}}" ng-click="$ctrl.scrollTo(w.hashName);" />
                                    <div class="sharable-dashboard-nav-panel__title">{{w.title}}</div>
                                </div>
                            </a>
                            <md-tooltip md-direction="right" md-delay="350">{{w.title}}</md-tooltip>
                        </div>
                    </div>
                </div>
                <div id="sharable-dashboard-editor" class="sharable-dashboard" ng-class="{'is-editing': $ctrl.isEditing}"></div>
            </div>
        </div>
        <script type="text/ng-template" id="toastCustomTemplate">
            <md-toast>
               <span class="md-toast-text" flex>{{notification}}</span>
               <md-button ng-click="close()">{{'OK' | translate}}</md-button>
            </md-toast>
        </script>
    `,
};

class SharableDashboardBuilderPreviewComponent {
  constructor(
    $rootScope,
    $scope,
    $compile,
    $window,
    $location,
    $timeout,
    $http,
    $mdMedia,
    $mdDialog,
    $mdToast,
    $cookieStore,
    stateService,
    Upload,
    CoreCompanyService,
    SHARABLE_DASHBOARD_URL,
    NEW_SHARABLE_DASHBOARD_URL,
    CDN_DOMAIN,
    DASHBOARD_SERVICES_URL,
    FAIRHAIR_WEB_URL,
    ANALYZE_WEB_URL,
    $translate
  ) {
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$compile = $compile;
    this.$window = $window;
    this.$location = $location;
    this.$timeout = $timeout;
    this.$http = $http;
    this.$mdMedia = $mdMedia;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$cookieStore = $cookieStore;
    this.stateService = stateService;
    this.Upload = Upload;
    this.CoreCompanyService = CoreCompanyService;
    this.SHARABLE_DASHBOARD_URL = SHARABLE_DASHBOARD_URL;
    this.NEW_SHARABLE_DASHBOARD_URL = NEW_SHARABLE_DASHBOARD_URL;
    this.CDN_DOMAIN = CDN_DOMAIN;
    this.DASHBOARD_SERVICES_URL = DASHBOARD_SERVICES_URL;
    this.FAIRHAIR_WEB_URL = FAIRHAIR_WEB_URL;
    this.ANALYZE_WEB_URL = ANALYZE_WEB_URL;
    this.$translate = $translate;

    this.requestInProgress = false;

    $rootScope.$on(
      "share-dashboard__add-widget",
      function (event, args) {
        this.cancel();
        this.addWidget(args.type);
      }.bind(this)
    );

    this.dragControlListeners = {
      accept: function (sourceItemHandleScope, destSortableScope) {
        return true;
      },
      itemMoved: function (event) {},
      orderChanged: function (event) {},
      // containment: '#board'//optional param.
      // clone: true //optional param for clone feature.
      // allowDuplicates: false //optional param allows duplicates to be dropped.
    };

    this.tinymceOptions = {
      selector: "textarea",

      // Skin
      content_css: "/js/dist/skins/meltwater2.0/content.min.css",
      skin: "meltwater2.0",
      skin_url: "/js/dist/skins/meltwater2.0",
      theme: "modern",

      // editor settings
      branding: false,
      height: 364,
      resize: false,
      menubar: "",
      elementpath: false,
      toolbar_items_size: "small",
      toolbar:
        "fontsizeselect | forecolor | bold italic underline | bullist numlist | outdent indent | align | link image",
      font_formats:
        "Helvetica=helvetica,Sans Serif=helvetica,sans-serif;Serif=times new roman,times,serif;Fixed Width=monospace;Comic Sans MS=comic sans ms,sans-serif;Garamond=garamond,serif;Georgia=georgia,serif;Tahoma=tahoma,arial,helvetica,sans-serif;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva",
      fontsize_formats:
        "8px 9px 10px 11px 12px 13px 14px 15px 16px 18px 24px 36px", //'8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 18pt 24pt 36pt',

      // Plugins Config

      // image
      image_description: false,
      image_title: false,
      //file_browser_callback_types: 'image',
      file_picker_types: "image",
      automatic_uploads: true,
      images_upload_url: `/aws/s3/images/${this.dashboardId}`,
      images_reuse_filename: true,

      // link
      default_link_target: "_blank",
      link_context_toolbar: true,
      link_title: false,
      target_list: false,

      // Unused: template setup stuff
      setup: (editor) => {
        // focus the editor on load
        // $timeout(() => {
        //     editor.focus();
        // });
        // Set the font size and font name on init
        editor.on("init", () => {
          //  editor.execCommand('fontName', false, 'helvetica');
          //  editor.execCommand('fontSize', false, '14px');
        });
        // This is how you could handle any onclick actions
        editor.on("click", function () {
          //...
        });
      },
      plugins: "advlist lists link image",
    };
  }

  $onInit() {
    const isProd = window.location.hostname.indexOf(".com") !== -1;
    //Check premium entitlements on delay if needed to give time for entitlements to load
    if (this.stateService.entitlements.length > 0) {
      this.setPremiumEntitlements()
    } else {
      //Manually load entitlements if they are not available when this controller is loaded
      const manifestClient: any = window[EXTERNAL_NAME];
      if (!manifestClient) {
        throw new Error(
          "Could not find Manifest Client"
        );
      }
      let currentManifestEnvironment;
      if (isProd) {
        currentManifestEnvironment = manifestClient.Environments.PRODUCTION;
      } else {
        currentManifestEnvironment = manifestClient.Environments.STAGING;
      }

      manifestClient.Initializer.initialize(currentManifestEnvironment);
      manifestClient.ManifestClient.getInstance()
        .then(maniInstance => maniInstance.getCurrentManifest())
        .then(mani => {
          this.stateService.entitlements = mani.entitlements.v6;
          this.setPremiumEntitlements()
        })
    }



    this.CoreCompanyService.getCurrent(true)
      .then(
        function (company) {
          this.company = company;
          this.linkConfig.companyId = company._id;
          if (this.generateContent) {
            this.contentAvailable = false;
            this.showLoading = true;
            this.generateReportContent();
          } else {
            this.requestInProgress = true;
            this.contentAvailable = true;
            this.showLoading = false;
            this.retrieveReportContent();
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.requestInProgress = false;
          console.log("Unable to retrieve company information", err);
        }.bind(this)
      );
  }

  setPremiumEntitlements() {
    this.canOverrideWatermark =
      this.stateService.entitlements["sharable-dashboards-premium"] !==
      undefined &&
      this.stateService.entitlements["sharable-dashboards-premium"] !== null &&
      this.stateService.entitlements["sharable-dashboards-premium"].value ===
      true;
  }

  retrieveReportContent() {
    var config = {
      method: "GET",
      url: "/aws/dynamoDb/sharableDashboard/" + this.dashboardId,
    };

    this.$http(config)
      .then(
        function (report) {
          if (report.data.Item) {
            this.linkConfig.title = report.data.Item.title || "";
            this.linkConfig.id = report.data.Item.id || "";
            this.linkConfig.dashboardId = report.data.Item.dashboardId || "";
            this.linkConfig.created = report.data.Item.created || "";
            this.linkConfig.modified = report.data.Item.created || "";
            this.linkConfig.password = report.data.Item.password || null;

            this.$http
              .get(
                "/sharable_dashboard_content/" +
                  this.linkConfig.companyId +
                  "/" +
                  this.dashboardId +
                  "?cb=" +
                  new Date().getTime()
              )
              .then(
                function (content) {
                  this.renderContent(
                    content.data.html || "",
                    content.data.widgets || ""
                  );
                  this.requestInProgress = false;
                  if (
                    Array.isArray(content.data.unsupportedWidgets) &&
                    content.data.unsupportedWidgets.length > 0
                  ) {
                    this.showUnsupportedWidgets(
                      content.data.unsupportedWidgets
                    );
                  }
                }.bind(this)
              )
              .catch(
                function (err) {
                  console.log(err);
                }.bind(this)
              );
          }
        }.bind(this)
      )
      .catch(function (err) {
        console.log("Error fetching report configuration ", err);
      });
  }

  generateReportContent() {
    this.creatingReportFlag = true;
    let dbUrl =
      "https://staging.meltwater.net/analyze/api/legacyDashboardServices/dashboard/";
    if (window.location.hostname.indexOf(".com") !== -1) {
      dbUrl =
        "https://app.meltwater.com/analyze/api/legacyDashboardServices/dashboard/";
    }
    var previousCoverLogos = this.getCookie("mwSDRPreviousLogos"),
      previousCoverWatermarks = this.getCookie("mwSDRPreviousWatermarks");

    this.$http
      .get(dbUrl + this.dashboardId)
      .then(
        function (res) {
          if (res.data._id !== undefined) {
            this.linkConfig.title = res.data.title || "";
            this.isDirty = true;

            var entitlementsDomain =
              "https://v6.staging.entitlements.meltwater.io";
            if (window.location.hostname.indexOf(".com") !== -1) {
              entitlementsDomain = "https://v6.entitlements.meltwater.io";
            }

            // this.$http.get(entitlementsDomain + '/company/' + this.company._id + '/entitlements/all').then(function(entitlementsResponse) {

            //     if(entitlementsResponse !== undefined) {
            //         this.stateService.entitlements = entitlementsResponse.data;
            //     }

            var config = {
              method: "POST",
              url: "/sharable-dashboard-create",
              data: {
                report: res.data,
                entitlements:
                  this.stateService.entitlements !== undefined &&
                  this.stateService.entitlements !== null
                    ? this.stateService.entitlements
                    : {},
              },
            };
            this.$http(config)
              .then(
                function (res) {
                  this.renderContent(
                    res.data.html || "",
                    res.data.widgets || []
                  );
                  if (
                    previousCoverLogos !== undefined &&
                    previousCoverLogos !== null &&
                    previousCoverLogos[this.company._id] !== undefined &&
                    previousCoverLogos[this.company._id] !== null
                  ) {
                    // Set logo to the last one used for this company
                    this.updateCoverBackground(
                      previousCoverLogos[this.company._id]
                    );
                    angular.element("#_cover-image-source")[0].value =
                      previousCoverLogos[this.company._id];
                    this.previousCoverImgSrc =
                      previousCoverLogos[this.company._id];
                  }
                  if (
                    previousCoverWatermarks !== undefined &&
                    previousCoverWatermarks !== null &&
                    previousCoverWatermarks[this.company._id] !== undefined &&
                    previousCoverWatermarks[this.company._id] !== null
                  ) {
                    // Set logo to the last one used for this company
                    this.updateWatermark(
                      previousCoverWatermarks[this.company._id]
                    );
                    angular.element("#_watermark-image-source")[0].value =
                      previousCoverWatermarks[this.company._id];
                    this.previousWatermarkImgSrc =
                      previousCoverWatermarks[this.company._id];
                  }
                  this.linkConfig.dateRange = res.data.dateRange || [];
                  this.linkConfig.id = res.data.reportId || undefined;
                  this.linkConfig.drilldownIds = res.data.drilldownIds || [];
                  this.requestInProgress = false;
                  this.contentAvailable = true;
                  if (
                    Array.isArray(res.data.unsupportedWidgets) &&
                    res.data.unsupportedWidgets.length > 0
                  ) {
                    this.showUnsupportedWidgets(res.data.unsupportedWidgets);
                  }
                }.bind(this)
              )
              .catch(function (err) {
                console.log("Error generating report ", err);
              });

            // }.bind(this));
          } else {
            this.notFound = true;
            this.creatingReportFlag = false;
            this.requestInProgress = false;
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          console.log("Unable to fetch dashboard informations ", err);
          this.notFound = true;
          this.creatingReportFlag = false;
          this.requestInProgress = false;
        }.bind(this)
      );
  }

  renderContent(html, widgets) {
    this.widgets = widgets;
    this.widgets = this.getThumbnailsSrcs(this.widgets);

    angular
      .element("#sharable-dashboard-editor")
      .append(this.$compile(html)(this.$scope));
    if (angular.element("#_cover-image-source").length > 0) {
      this.previousCoverImgSrc = angular.element(
        "#_cover-image-source"
      )[0].value;
    }
    if (angular.element("#_watermark-image-source").length > 0) {
      this.previousWatermarkImgSrc = angular.element(
        "#_watermark-image-source"
      )[0].value;
    }

    this.$timeout(
      function () {
        this.$location.hash(this.widgets[0].hashName);

        if (
          angular.element(".mdl-typography--footer__cover-daterange").length > 0
        ) {
          this.linkConfig.subtitle = angular
            .element(
              "#" +
                this.$location.hash() +
                " .mdl-typography--footer__cover-daterange"
            )
            .text();
        }
      }.bind(this),
      750
    );

    this.$timeout(function () {
      // After animations are done, reflow all the charts so that they honor the width they're supposed to have in the builder
      // This isn't a problem for viewing the final report
      if (Highcharts !== undefined && Highcharts.charts !== undefined) {
        for (var key in Highcharts.charts) {
          if (
            Highcharts.charts[key] !== undefined &&
            Highcharts.charts[key] !== null
          ) {
            Highcharts.charts[key].reflow();
          }
        }
      }

      // This is a global function defined in highcharts-modifiers.js
      // It's a pretty hacky way of doing this, but it's convenient to use it this way here in the Angular app
      //   as well as in the final, non-Angular view
      hideLastColumnGridline();
    }, 1600);
  }

  getThumbnailsSrcs(widgets) {
    var thumbnailSrc;
    for (var key in widgets) {
      thumbnailSrc = "https://via.placeholder.com/140x70";
      switch (widgets[key].type) {
        case "cover":
          thumbnailSrc = "/img/sdb-cover.png";
          break;
        case "divider":
          thumbnailSrc = "/img/sdb-divider.png";
          break;
        case "summary":
        case "conclusion":
          thumbnailSrc = "/img/sdb-summary-widget.png";
          break;
        case "content-stream":
        case "top-social-echo":
          thumbnailSrc = "/img/sdb-content-stream-widget.png";
          break;
        case "social-reach":
          thumbnailSrc = "/img/sdb-social-reach.png";
          break;
        case "media-exposure":
        case "social-media-exposure":
        case "reach-exposure":
          if (widgets[key].graphType === "column") {
            thumbnailSrc = "/img/sdb-column.png";
          } else if (widgets[key].graphType === "donut") {
            thumbnailSrc = "/img/sdb-sov.png";
          } else {
            thumbnailSrc = "/img/sdb-media-exposure.png";
          }
          break;
        case "media-exposure-highlights":
          thumbnailSrc = "/img/sdb-media-exposure-highlights.png";
          break;
        case "tonality-score":
          if (widgets[key].graphType === "column") {
            thumbnailSrc = "/img/sdb-sentiment-column.png";
          } else {
            thumbnailSrc = "/img/sdb-media-exposure.png";
          }
          break;
        case "top-publications":
          thumbnailSrc = "/img/sdb-top-publications.png";
          break;
        case "keyphrase":
          thumbnailSrc = "/img/sdb-keyphrases.png";
          break;
        case "geo-presence":
        case "geo-presence-country":
          thumbnailSrc = "/img/sdb-heat-map.png";
          break;
        case "tonality":
          if (widgets[key].graphType === "column") {
            thumbnailSrc = "/img/sdb-sentiment-column.png";
          } else if (widgets[key].graphType === "donut") {
            thumbnailSrc = "/img/sdb-sentiment-donut.png";
          } else if (widgets[key].graphType === "spline") {
            thumbnailSrc = "/img/sdb-media-exposure.png";
          }
          break;
        case "sov-volume":
          if (widgets[key].graphType === "column") {
            thumbnailSrc = "/img/sdb-column.png";
          } else if (widgets[key].graphType === "spline") {
            thumbnailSrc = "/img/sdb-media-exposure.png";
          } else {
            thumbnailSrc = "/img/sdb-sov.png";
          }
          break;
        case "google-analytics":
          thumbnailSrc = "/img/sdb-google-analytics.png";
          break;
        default:
          break;
      }
      widgets[key].thumbnailSrc = thumbnailSrc;
    }
    return widgets;
  }

  addWidget(type) {
    var name = null,
      template = null,
      insertAfter = null;
    if (type === "divider") {
      insertAfter = "#" + this.$location.hash();
      name = "slideDivider" + new Date().getTime();
      template = angular
        .element("#divider-slide__template")
        .html()
        .replace(/@@NAME@@/g, name);
      this.widgets.splice(this.findWidgetIndexFromHash() + 1, 0, {
        title: this.$translate.instant("Divider"),
        type: "divider",
        hashName: name,
        thumbnailSrc: "/img/sdb-divider.png",
      });
    } else if (type === "summary") {
      // Find the last summary OR cover OR make it the first slide
      var lastSummaryIdx = -1,
        coverIdx = -1,
        insertAfterIdx = 0;
      for (var idx in this.widgets) {
        if (this.widgets[idx].type === "cover") {
          coverIdx = idx;
        } else if (this.widgets[idx].type === "summary") {
          lastSummaryIdx = idx;
        } else {
          break;
        }
      }
      if (lastSummaryIdx >= 0) {
        insertAfterIdx = parseInt(lastSummaryIdx);
      } else if (coverIdx >= 0) {
        insertAfterIdx = parseInt(coverIdx);
      }
      insertAfter = "#" + this.widgets[insertAfterIdx].hashName;
      name = "slideSummary" + new Date().getTime();
      template = angular
        .element("#summary-slide__template")
        .html()
        .replace(/@@NAME@@/g, name);
      this.widgets.splice(insertAfterIdx + 1, 0, {
        title: this.$translate.instant("Summary"),
        type: "summary",
        hashName: name,
        thumbnailSrc: "/img/sdb-summary-widget.png",
      });
    } else if (type === "conclusion") {
      insertAfter = "#" + this.widgets[this.widgets.length - 1].hashName;
      name = "slideConclusion" + new Date().getTime();
      template = angular
        .element("#summary-slide__template")
        .html()
        .replace(/@@NAME@@/g, name);
      this.widgets.push({
        title: this.$translate.instant("Conclusion"),
        type: "conclusion",
        hashName: name,
        thumbnailSrc: "/img/sdb-summary-widget.png",
      });
    }
    if (template !== null) {
      angular
        .element(this.$compile(template)(this.$scope))
        .insertAfter(insertAfter);
      this.$location.hash(name);
      this.isDirty = true;
    }
  }

  editWidget() {
    this.$timeout(
      function () {
        this.isEditing = true;
        this.currentSlide = this.$location.hash();

        if (this.currentSlide === "slideCover") {
          this.coverImgSrc = angular.element("#_cover-image-source")[0].value;
          if (angular.element("#_cover-image-source").length > 0) {
            this.previousCoverImgSrc = angular.element(
              "#_cover-image-source"
            )[0].value;
          }

          this.footerWatermarkLogo =
            angular.element("#_watermark-image-source")[0] !== undefined
              ? angular.element("#_watermark-image-source")[0].value
              : "";
          if (angular.element("#_watermark-image-source").length > 0) {
            this.previousWatermarkImgSrc = angular.element(
              "#_watermark-image-source"
            )[0].value;
          }

          this.updateCoverBackground(this.coverImgSrc);
          this.updateWatermark(this.footerWatermarkLogo);
        }

        var enableInlineEdit = function (selector, template) {
          var editableEle;
          var editableElements = angular.element(selector);
          for (var key in editableElements) {
            if (!isNaN(parseInt(key))) {
              editableEle = angular.element(editableElements[key])[0];
              angular
                .element(this.$compile(template)(this.$scope))
                .insertAfter(editableEle);
            }
          }
        }.bind(this);

        // Temporarily inject some input controls to allow editing.  When done with them, they'll be removed because we don't need/want them in the static HTML of the final product
        enableInlineEdit(
          "#" + this.$location.hash() + " .is-editable",
          '<md-input-container class="should-clean-up" ng-show="$ctrl.hideEverything !== true && $ctrl.isEditing === true"><input ng-model="$ctrl.currentTitle" md-maxlength="55" maxlength="55" aria-label="Title" /></md-input-container>'
        );
        enableInlineEdit(
          "#" + this.$location.hash() + " .is-editable-subtitle",
          '<md-input-container class="should-clean-up footer__subtitle__input" ng-show="$ctrl.hideEverything !== true && $ctrl.isEditing === true"><input ng-model="$ctrl.currentSubtitle" md-maxlength="55" maxlength="55" aria-label="Subtitle" /></md-input-container>'
        );
        enableInlineEdit(
          "#" + this.$location.hash() + " .is-editable-multi-line",
          '<md-input-container class="should-clean-up" ng-show="$ctrl.hideEverything !== true && $ctrl.isEditing === true"><textarea ng-model="$ctrl.currentSummary" rows="2" md-maxlength="225" maxlength="225" aria-label="Summary"></textarea></md-input-container>'
        );
        enableInlineEdit(
          "#" + this.$location.hash() + " .is-editable-as-html",
          '<md-input-container class="should-clean-up" ng-show="$ctrl.hideEverything !== true && $ctrl.isEditing === true"><textarea ng-model="$ctrl.currentSummary" ui-tinymce="$ctrl.tinymceOptions" rows="20" aria-label="Summary"></textarea></md-input-container>'
        );

        angular
          .element( "#" +
          this.$location.hash() +
          " .sharable-dashboard__summary-text-container"
          )
          .addClass(
            'hide-me'
          )


        this.currentTitle = angular
          .element("#" + this.$location.hash() + " .mdl-typography--title")
          .text();
        this.currentSubtitle = angular
          .element(
            "#" +
              this.$location.hash() +
              " .mdl-typography--footer__cover-daterange"
          )
          .text();
        if (
          this.$location.hash().indexOf("slideSummary") === 0 ||
          this.$location.hash().indexOf("slideConclusion") === 0
        ) {
          this.currentSummary = angular
            .element(
              "#" +
                this.$location.hash() +
                " .sharable-dashboard__summary-container"
            )
            .html();
        } else {
          this.currentSummary = angular
            .element(
              "#" +
                this.$location.hash() +
                " .sharable-dashboard__summary-container"
            )
            .text()
            .replace(/0 \/ 225$/, "");
        }
        delete this.hideEverything;
      }.bind(this),
      1
    );
  }

  deleteWidget(ev) {
    var idx = this.findWidgetIndexFromHash(),
      title = this.$translate.instant("Delete {{title}} from the dashboard?", {
        title: this.widgets[idx].title,
      }),
      okLabelAction = this.$translate.instant("Delete"),
      cancelLabelAction = this.$translate.instant("Keep");

    this.$mdDialog
      .show(
        this.$mdDialog
          .mwConfirm()
          .multiple(true)
          .title(title)
          .ok(okLabelAction)
          .cancel(cancelLabelAction)
          .targetEvent(ev)
          .parent(
            angular.element(
              document.getElementsByClassName("mw-flexi-modal")[0]
            )
          )
      )
      .then(
        function okHandler() {
          angular.element("#" + this.$location.hash()).remove();
          // Change location hash to next (or previous if there is no next) slide
          if (this.widgets[idx + 1] !== undefined) {
            this.$location.hash(this.widgets[idx + 1].hashName);
          } else if (this.widgets[idx - 1] !== undefined) {
            this.$location.hash(this.widgets[idx - 1].hashName);
          }
          this.widgets.splice(idx, 1);
          this.isDirty = true;
        }.bind(this),
        function cancelHandler() {}
      );
  }

  findWidgetIndexFromHash() {
    var index = -1;
    for (var idx = 0; idx < this.widgets.length; idx++) {
      if (this.widgets[idx].hashName === this.$location.hash()) {
        index = idx;
        break;
      }
    }
    return index;
  }

  saveWidget() {
    this.hideEverything = true;
    this.$timeout(
      function () {
        this.isEditing = false;
        this.isDirty = true;

        if (
          this.currentSlide === "slideCover" &&
          this.coverImgSrc.indexOf("meltwater-logo_2x.png") < 0
        ) {
          angular.element("#_cover-image-source")[0].value = this.coverImgSrc;
          this.updateCoverBackground(this.coverImgSrc);

          angular.element("#_watermark-image-source")[0].value =
            this.footerWatermarkLogo;
          this.updateWatermark(this.footerWatermarkLogo);

          this.linkConfig.title = this.currentTitle;
          this.linkConfig.subtitle = this.currentSubtitle;
          this.previousCoverImgSrc = this.coverImgSrc;
          this.previousWatermarkImgSrc = this.footerWatermarkLogo;

          this.saveToCookie("mwSDRPreviousLogos", this.coverImgSrc);
          this.saveToCookie(
            "mwSDRPreviousWatermarks",
            this.footerWatermarkLogo
          );

          delete this.coverImgSrc;
        }

        angular
          .element("#" + this.$location.hash() + " .mdl-typography--title")
          .text(this.currentTitle);
        angular
          .element("#" + this.$location.hash() + " [data-rpt-cover-title]")
          .attr("data-rpt-cover-title", this.currentTitle);
        angular
          .element("#" + this.$location.hash() + " [data-rpt-chart-title]")
          .attr("data-rpt-chart-title", this.currentTitle);
        angular
          .element("#" + this.$location.hash() + " [data-rpt-summary-title]")
          .attr("data-rpt-summary-title", this.currentTitle);
        angular
          .element("#" + this.$location.hash() + " [data-rpt-divider-title]")
          .attr("data-rpt-divider-title", this.currentTitle);
        angular
          .element("#" + this.$location.hash() + " [data-rpt-chart-description]")
          .attr("data-rpt-chart-description", this.currentSummary);

        angular
          .element(
            "#" +
              this.$location.hash() +
              " .mdl-typography--title .md-errors-spacer"
          )
          .remove();
        angular
          .element(
            "#" +
              this.$location.hash() +
              " .mdl-typography--footer__cover-daterange"
          )
          .text(this.currentSubtitle);
        const dataRptCoverDateRangeElem = angular
          .element(
            "#" +
              this.$location.hash() +
              " [data-rpt-cover-date-range]"
          )
        if (dataRptCoverDateRangeElem) {
          dataRptCoverDateRangeElem.attr("data-rpt-cover-date-range", this.currentSubtitle)
        }

        angular
        .element( "#" +
        this.$location.hash() +
        " .sharable-dashboard__summary-text-container"
        )
        .removeClass(
          'hide-me'
        );
        angular
          .element(
            "#" +
              this.$location.hash() +
              " .sharable-dashboard__summary-text-container"
          )
          .html(
            anchorme(this.currentSummary, {
              attributes: [{ name: "target", value: "_blank" }],
            })
          );
          angular
          .element(
            "#" +
              this.$location.hash() +
              " .sharable-dashboard__summary-text-container"
          )
          .append(
            '<span data-rpt-chart-description="'+ this.currentSubtitle +'" class="sharable-dashboard__summary-text-container"><div class="is-editable-multi-line" aria-hidden="false" style=""></div></span>'
          )
        angular
          .element(
            "#" +
              this.$location.hash() +
              " .sharable-dashboard__summary-text-container .md-errors-spacer"
          )
          .remove();

        angular
          .element(
            "#" + this.$location.hash() + " md-input-container.should-clean-up"
          )
          .remove();

        delete this.currentTitle;
        delete this.currentSubtitle;
        delete this.currentSummary;
        delete this.hideEverything;
      }.bind(this),
      500
    );
  }

  getCookie(name) {
    var obj = this.$cookieStore.get(name);
    if (obj !== undefined && obj !== null) {
      obj = JSON.parse(obj);
    }
    return obj;
  }

  saveToCookie(name, val) {
    var obj = this.$cookieStore.get(name);
    if (obj === undefined || obj === null) {
      obj = {};
    } else {
      obj = JSON.parse(obj);
    }
    obj[this.company._id] = val;
    this.$cookieStore.put(name, JSON.stringify(obj));
  }

  cancel() {
    this.hideEverything = true;
    this.$timeout(
      function () {
        this.isEditing = false;

        if (
          this.currentSlide === "slideCover" &&
          this.previousCoverImgSrc !== undefined
        ) {
          this.updateCoverBackground(this.previousCoverImgSrc);
          angular.element("#_cover-image-source")[0].value =
            this.previousCoverImgSrc;
          delete this.coverImgSrc;
          delete this.previousCoverImgSrc;
        }
        if (this.currentSlide === "slideCover") {
          this.footerWatermarkLogo =
            this.previousWatermarkImgSrc !== undefined
              ? this.previousWatermarkImgSrc
              : "";
          angular.element("#_watermark-image-source")[0].value =
            this.footerWatermarkLogo;
          this.updateWatermark(this.footerWatermarkLogo);
        }
        angular
          .element(
            "#" + this.$location.hash() + " md-input-container.should-clean-up"
          )
          .remove();
        delete this.currentTitle;
        delete this.currentSubtitle;
        delete this.currentSummary;
        delete this.hideEverything;
      }.bind(this),
      1
    );
  }

  changeSlide() {
    this.cancel();
    if (
      window.sdrCurrentOpenDrilldownHash !== undefined &&
      window.sdrCurrentOpenDrilldownHash !== null &&
      $(window.sdrCurrentOpenDrilldownHash + " #drilldown-container").length > 0
    ) {
      $(window.sdrCurrentOpenDrilldownHash + " #drilldown-container").fadeOut(
        function () {
          $(
            window.sdrCurrentOpenDrilldownHash + " .drilldown__back-button"
          ).css("display", "none");
          $(
            window.sdrCurrentOpenDrilldownHash + " #drilldown-container"
          ).remove();
          $(window.sdrCurrentOpenDrilldownHash + " .height-container").show();
        }
      );
    }
  }

  uploadFile($file) {
    this.previousCoverImgSrc = this.coverImgSrc;
    if ($file !== undefined && $file !== null) {
      this.requestInProgress = true;
      this.Upload.upload({
        url: "/aws/s3/" + this.linkConfig.companyId,
        file: $file,
      })
        .progress(function (e) {})
        .then(
          function (res, status, headers, config) {
            this.coverImgSrc = res.data.url;
            this.updateCoverBackground(this.coverImgSrc);
            this.requestInProgress = false;
          }.bind(this)
        )
        .catch(function (err) {
          //do something if the upload fails?
        });
    }
  }

  uploadWatermarkFile($file) {
    this.previousWatermarkImgSrc = this.footerWatermarkLogo;
    if ($file !== undefined && $file !== null) {
      this.requestInProgress = true;
      this.Upload.upload({
        url: "/aws/s3/" + this.linkConfig.companyId,
        file: $file,
      })
        .progress(function (e) {})
        .then(
          function (res, status, headers, config) {
            this.footerWatermarkLogo = res.data.url;
            this.updateWatermark(this.footerWatermarkLogo);
            this.requestInProgress = false;
          }.bind(this)
        )
        .catch(function (err) {
          //do something if the upload fails?
        });
    }
  }

  updateCoverBackground(imgSrc) {
    if (imgSrc === undefined) {
      imgSrc = angular.element("#_cover-image-source")[0].value;
    }

    //any better way to determine if the default image comes from our generator?
    var isDefaultCoverImg =
      imgSrc.indexOf(this.NEW_SHARABLE_DASHBOARD_URL) === 0 ||
      imgSrc.indexOf(this.CDN_DOMAIN) === 0
        ? true
        : false;
    if (isDefaultCoverImg) {
      angular
        .element(".sharable-dashboard-footer__watermark")
        .css({ display: "none" });
    } else {
      angular
        .element(".sharable-dashboard-footer__watermark")
        .css({ display: "block" });
    }

    angular.element(".main-section.cover > img").attr("src", imgSrc);
    angular.element(".main-section.cover > img").attr("data-rpt-cover-image", imgSrc);
  }

  updateWatermark(imgSrc) {
    if (imgSrc === undefined) {
      imgSrc = angular.element("#_watermark-image-source")[0].value;
    }

    angular
      .element(".sharable-dashboard-footer__watermark-container > img")
      .attr("src", imgSrc);
  }

  isDefaultLogo() {
    return (
      this.coverImgSrc === undefined ||
      this.coverImgSrc === null ||
      this.coverImgSrc.indexOf(this.NEW_SHARABLE_DASHBOARD_URL) === 0 ||
      this.coverImgSrc.indexOf(this.CDN_DOMAIN) === 0
    );
  }

  isDefaultWatermark() {
    return (
      this.footerWatermarkLogo === undefined ||
      this.footerWatermarkLogo === null ||
      this.footerWatermarkLogo.indexOf(this.NEW_SHARABLE_DASHBOARD_URL) === 0 ||
      this.footerWatermarkLogo.indexOf(this.CDN_DOMAIN) === 0
    );
  }

  removeCustomLogo() {
    var defaultLogo =
      this.NEW_SHARABLE_DASHBOARD_URL + "/img/watermark_2x_black.png?cb=123";
    this.coverImgSrc = defaultLogo;
    angular.element("#_cover-image-source")[0].value = defaultLogo;
    this.updateCoverBackground(defaultLogo);
    this.removeCustomWatermark();
  }

  removeCustomWatermark() {
    var defaultWatermark =
      this.NEW_SHARABLE_DASHBOARD_URL + "/img/meltwater-logo_2x.png?cb=123";
    this.footerWatermarkLogo = defaultWatermark;
    angular.element("#_watermark-image-source")[0].value = defaultWatermark;
    this.updateWatermark(defaultWatermark);
  }

  showUnsupportedWidgets(unsupportedWidgets) {
    var notification = this.$translate.instant(
        "We currently do not support {{unsupportedCount}} widgets in the Shared Dashboard",
        { unsupportedCount: unsupportedWidgets.length }
      ),
      displayNames = [],
      unsupportedMap = {
        "momentum-widget": this.$translate.instant("Topic Momentum"),
        "image-widget": this.$translate.instant("Image"),
        "text-widget": this.$translate.instant("Text"),
        "media-exposure-highlights-widget": "Total Media Exposure",
      };

    if (unsupportedWidgets.length < 3) {
      displayNames = unsupportedWidgets.map(function (widget) {
        return unsupportedMap[widget] !== undefined
          ? unsupportedMap[widget]
          : widget;
      });

      notification = this.$translate.instant(
        "We currently do not support {{unsupportedList}} widgets in the Shared Dashboard",
        { unsupportedList: displayNames.join(", ") }
      );
    }

    this.toast = this.$mdToast.show(
      this.$mdToast.mwMultipleActions({
        templateUrl: "toastCustomTemplate",
        locals: {
          notification: notification,
        },
        controller: function ($scope, $mdToast, notification) {
          $scope.notification = notification;
          $scope.close = function () {
            $mdToast.cancel();
          };
        },
      })
    );
  }

  backToDashboard() {
    this.$window.location.href =
      this.ANALYZE_WEB_URL + "/analyze/dashboard/viewer/" + this.dashboardId;
  }
}

sharableDashboardBuilderPreviewConfig.controller =
  SharableDashboardBuilderPreviewComponent;

export {
  sharableDashboardBuilderPreviewConfig,
  SharableDashboardBuilderPreviewComponent as default,
};
